import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Text } from '../../atoms';

const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ $backgroundColor }) => $backgroundColor};
  min-height: 52px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 8px;
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

const Alert = ({
  icon,
  message,
  backgroundColor = 'var(--yellow-20)',
  actions = null,
  className = null
}) => (
  <AlertContainer $backgroundColor={backgroundColor} className={className}>
    <MessageContainer>
      {icon}
      <Text>{message}</Text>
    </MessageContainer>
    {actions}
  </AlertContainer>
);

Alert.propTypes = {
  icon: PropTypes.node.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  backgroundColor: PropTypes.string,
  actions: PropTypes.node,
  className: PropTypes.string
};

export { Alert };
